import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import { reduxForm, Field } from 'redux-form';
import { toastr } from 'react-redux-toastr';

import { ApiService } from 'services';
import { addSupportingDoc, getStorageSetting } from 'actions';

import AccessControl from 'components/AccessControl';
import ActivityPerms from 'components/AccessControl/permissions.json';

import FileUpload from 'components/Common/FileUpload';
import EvidentiaryDocs from 'components/EvidentiaryDocs';

class SupportingDocsSection extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    permissions: PropTypes.arrayOf(PropTypes.string),
    customerId: PropTypes.number,
    supportingDocError: PropTypes.shape({}),
  };

  static defaultProps = {
    permissions: null,
    customerId: null,
    supportingDocError: null,
  };

  constructor(props) {
    super(props);

    const files = getStorageSetting('files') || [];

    this.state = {
      supportingDocType: '',
      files
    };
  }

  static onFileUploadCancel(file) {
    toastr.info('', `Upload of ${ file.name } has been canceled.`);
  }

  static onFileUploadError(file, error) {
    toastr.error('', `Upload of ${ file.name } has been canceled.  ${ error.message }`);
  }

  static onViewSupportingDocument(file) {
    if (file) {
      window.open(`customers/supporting-docs/${ file.id }`, '_blank');
      return;
    }
    toastr.error('', 'Sorry, this document cannot be viewed');
  }

  onFileUploadSuccess(file, response) {
    const { dispatch } = this.props;

    response[0].uploadDate = new Date();

    dispatch(addSupportingDoc(response));
    toastr.success('', `${ response[0].originalFileName } has been uploaded`);
  }

  onSupportingDocTypeChange = (e, newValue) => this.setState({ supportingDocType: newValue });

  canUpload() {
    const { permissions, } = this.props;

    const hasReviewerPermission = AccessControl.hasPermission(permissions, [ActivityPerms.fwfInitialReviewer, ActivityPerms.fwfSecondaryReviewer, ActivityPerms.fwfExpertReviewer, ActivityPerms.fwfSupplReviewer]);

    return hasReviewerPermission;
  }

  render() {
    const { permissions, customerId } = this.props;
    const { files, supportingDocType } = this.state;

    return (
      <AccessControl permissions={ permissions } allowedPermissions={ [ActivityPerms.scannedSupDocs, ActivityPerms.scannedSupDocsInternal] }>
        { this.canUpload() && <div className="supporting-docs col-6 col-sm-12">
          <div className="panel-body-caption">
            <h3><strong>Upload Documents: </strong></h3>
          </div>
          <div className="supporting-docs-content">
            <form id="supportingDocForm" className="form-horizontal">
              <div>
                <div className="form-group">
                  <div className="col-4 col-sm-12">
                    <label htmlFor="supporting-doc-type" className="form-label">Document Type</label>
                  </div>
                  <div className="col-8 col-sm-12">
                    <Field
                      id="supporting-doc-type"
                      name="supportingDocType"
                      component={ EvidentiaryDocs }
                      className="form-select"
                      hideHints
                      value={ supportingDocType }
                      onChange={ (e, newValue) => this.onSupportingDocTypeChange(e, newValue) }
                    />
                  </div>
                </div>
                <FileUpload
                  defaultMessage="Drop files here to upload in bmp, gif, jpg, png, tif, doc, docx, xls, xlsx, msg or pdf format"
                  postUrl={ ApiService.getFileUploadUrl() }
                  accessTokenName={ ApiService.getAccessTokenName() }
                  acceptedFiles="application/pdf,.jpg,.png,.bmp,.msg,.doc,.docx,.jpeg,.tiff,.gif,.tif,.xls,.xlsx"
                  maxFilesize={ files.maxFilesize }
                  timeout={ files.uploadTimeout }
                  docCategory="supportingdocument"
                  docType={ supportingDocType != null ? supportingDocType : '' }
                  id={ customerId }
                  linkType="customer"
                  removeFileAfterUpload
                  onFileUploadCancel={ file => SupportingDocsSection.onFileUploadCancel(file) }
                  onFileUploadSuccess={ (file, response) => this.onFileUploadSuccess(file, response) }
                  onFileUploadError={ (file, error) => SupportingDocsSection.onFileUploadError(file, error) }
                />
              </div>
            </form>
          </div>
        </div>}
      </AccessControl>
    );
  }
}

const supportingDocForm = reduxForm({
  form: 'supportingDocForm',
})(SupportingDocsSection);

function mapStateToProps(state) {
  const {
    auth: {
      permissions
    },
    forms: {
      isDeletingSupportingDocId,
      supportingDocError
    },
  } = state;

  return {
    permissions,
    isDeletingSupportingDocId,
    supportingDocError,
  };
}

const mapDispatchToProps = dispatch => ({ dispatch });

export const SupportingDocsUpload = connect(
  mapStateToProps,
  mapDispatchToProps
)(supportingDocForm);

export default SupportingDocsUpload;
